<template>
<ul class="hidden xl:flex font-semibold font-heading">
	<li class="mr-12"><router-link to="/" class="text-gray-600 hover:text-blue-600" aria-label="Home">หน้าหลัก</router-link></li>
	<li class="mr-12"><router-link to="/course" class="hover:text-gray-600" aria-label="Course">หลักสูตร ส.อ.ท.</router-link></li>
	<li class="mr-12"><router-link to="/about" class="hover:text-gray-600" aria-label="About Me">เกี่ยวกับเรา</router-link></li>
	<li><router-link to="/contact" class="hover:text-gray-600" aria-label="Contact">ติดต่อเรา</router-link></li>
</ul>
</template>
